// extracted by mini-css-extract-plugin
module.exports =  {"image":"NmXwo_pqgne_PLpqOzos","placeholder":"MIJyUQH0TP9ftnW_H7rc","skeleton":"JHZiJbbaBJR_SreIeYRn"};